/**
 * Константы методов вывода кристаллов
 * При добавлении новых методов — расширять этот объект
 */

export const WITHDRAW_METHODS = {
  STEAM: 'steam',
  UZS: 'uzs',
  TJS: 'tjs',
  RUB_SBP: 'rub_sbp',
  RUB_CARD: 'rub_card',
  CRYPTO: 'crypto',
  STARS: 'stars',
}

/**
 * Метаданные методов вывода
 * available — доступен ли метод (может переопределяться флагом из /api/me/)
 */
export const WITHDRAW_METHODS_META = {
  [WITHDRAW_METHODS.STEAM]: {
    id: WITHDRAW_METHODS.STEAM,
    icon: 'Steam',
    available: true,
    // Флаг из /api/me/ для глобального включения/выключения
    enabledFlag: 'steam_topup_enabled',
    // strict=false: ключ приходит всегда, скрываем только при явном === false
    strict: false,
  },
  [WITHDRAW_METHODS.UZS]: {
    id: WITHDRAW_METHODS.UZS,
    icon: 'UZS',
    available: true,
    // Флаг из /api/me/. Для UZS «нет ключа = раздела нет»
    enabledFlag: 'uzs_withdraw_enabled',
    // strict=true: показываем только при явном === true (ключа может не быть вообще)
    strict: true,
  },
  [WITHDRAW_METHODS.TJS]: {
    id: WITHDRAW_METHODS.TJS,
    icon: 'TJS',
    available: true,
    enabledFlag: 'tjs_withdraw_enabled',
    strict: true,
  },
  // Вывод в рублях: один раздел API (/api/rub-withdraw/), два способа — отдельными карточками.
  // rubMethod — ключ в methods из GET /api/rub-withdraw/ (способ с enabled: false скрывается)
  [WITHDRAW_METHODS.RUB_SBP]: {
    id: WITHDRAW_METHODS.RUB_SBP,
    icon: 'SBP',
    available: true,
    enabledFlag: 'rub_withdraw_enabled',
    strict: true,
    rubMethod: 'sbp',
  },
  [WITHDRAW_METHODS.RUB_CARD]: {
    id: WITHDRAW_METHODS.RUB_CARD,
    icon: 'CardRub',
    available: true,
    enabledFlag: 'rub_withdraw_enabled',
    strict: true,
    rubMethod: 'card',
  },
  [WITHDRAW_METHODS.CRYPTO]: {
    id: WITHDRAW_METHODS.CRYPTO,
    icon: 'Crypto',
    available: true,
    // Флаг из /api/me/. Для Crypto «нет ключа = раздела нет» (модуль выключен либо нет пополнений)
    enabledFlag: 'crypto_withdraw_enabled',
    // strict=true: показываем только при явном === true (ключа может не быть вообще)
    strict: true,
  },
  [WITHDRAW_METHODS.STARS]: {
    id: WITHDRAW_METHODS.STARS,
    icon: 'Stars',
    available: true,
    // Флаг из /api/me/. «Нет ключа = раздела нет» (модуль выключен либо нет пополнений)
    enabledFlag: 'stars_withdraw_enabled',
    strict: true,
  },
}

/**
 * Порядок отображения методов вывода
 */
export const WITHDRAW_METHODS_ORDER = [
  WITHDRAW_METHODS.STEAM,
  WITHDRAW_METHODS.UZS,
  WITHDRAW_METHODS.TJS,
  WITHDRAW_METHODS.RUB_SBP,
  WITHDRAW_METHODS.RUB_CARD,
  WITHDRAW_METHODS.CRYPTO,
  WITHDRAW_METHODS.STARS,
]

/**
 * Получить список доступных методов вывода
 * @param {Object} user — объект пользователя из useAppStore
 * @returns {Array} массив доступных методов
 */
export const getAvailableWithdrawMethods = (user) => {
  return WITHDRAW_METHODS_ORDER
    .map((methodId) => WITHDRAW_METHODS_META[methodId])
    .filter((method) => {
      if (!method?.available) return false
      // Проверяем глобальный флаг из профиля пользователя
      if (method.enabledFlag) {
        if (method.strict) {
          // strict: показываем только при явном === true (ключа может не быть вообще)
          return user?.[method.enabledFlag] === true
        }
        // не strict: ключ приходит всегда, скрываем только при явном === false
        if (user?.[method.enabledFlag] === false) return false
      }
      return true
    })
}
